import { Selector, State, StateContext, Action } from '@ngxs/store';
import { BorrowerLoan } from 'app/models/dto/borrower-loan.model';
import {catchError, tap} from 'rxjs/operators';
import { BorrowerLoansService } from 'app/services/borrowerLoans/borrower-loans.service';
import { GetBorrowerLoans, UpdateBorrowerLoans, ClearBorrowerLoansStore, PatchBorrowerLoans } from './borrower-loans.actions';
import { Injectable } from '@angular/core';
import {of} from 'rxjs';

export class BorrowerLoansStateModel {
  borrowerLoans: BorrowerLoan[] | null;
}

@State<BorrowerLoansStateModel>({
	name: 'borrowerLoans',
	defaults: {
    borrowerLoans: []
	}
})

@Injectable()

export class BorrowerLoansState {

  @Selector()
	static borrowerLoans(state: BorrowerLoansStateModel) {
    return state.borrowerLoans;
  }

  constructor(
    private borrowerLoansService: BorrowerLoansService,
  ) {}

  @Action(GetBorrowerLoans)
	getBorrowerLoans({ patchState }: StateContext<BorrowerLoansStateModel>, { borrowerId }: GetBorrowerLoans) {
    return this.borrowerLoansService.get(borrowerId)
      .pipe(
        tap(borrowerLoans => {
          patchState({ borrowerLoans });
        }),
        catchError( error => {
          console.error(error);
          return of();
        }),
      );
  }

  @Action(UpdateBorrowerLoans)
	updateBorrowerLoans({ patchState }: StateContext<BorrowerLoansStateModel>, { borrowerId, updates }: UpdateBorrowerLoans) {
    return this.borrowerLoansService.update(borrowerId, updates)
      .pipe(
        tap(borrowerLoans => {
          patchState({ borrowerLoans });
        }),
        catchError( error => {
          console.error(error);
          return of();
        }),
      );
  }

  @Action(ClearBorrowerLoansStore)
	clearBorrowerLoansStore({ patchState }: StateContext<BorrowerLoansStateModel>, { }: ClearBorrowerLoansStore) {
    patchState({ borrowerLoans: null });
	}

  @Action(PatchBorrowerLoans)
	patchBorrowerLoans({ patchState }: StateContext<BorrowerLoansStateModel>, { borrowerLoans }: PatchBorrowerLoans) {
    const borrowerLoansCopy = JSON.parse(JSON.stringify(borrowerLoans));
    patchState({ borrowerLoans: borrowerLoansCopy });
	}
}
